/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ChallengeEligibilityMap } from './ChallengeEligibilityMap';
import {
    ChallengeEligibilityMapFromJSON,
    ChallengeEligibilityMapFromJSONTyped,
    ChallengeEligibilityMapToJSON,
    ChallengeEligibilityMapToJSONTyped,
} from './ChallengeEligibilityMap';

/**
 * 
 * @export
 * @interface ChallengeRegisterRequest
 */
export interface ChallengeRegisterRequest {
    /**
     * 
     * @type {ChallengeEligibilityMap}
     * @memberof ChallengeRegisterRequest
     */
    eligibility?: ChallengeEligibilityMap;
    /**
     * Version identifier of the terms accepted (e.g. "v1").
     * @type {string}
     * @memberof ChallengeRegisterRequest
     */
    termsVersion: string;
    /**
     * ISO-3166-1 alpha-2 country code the user selected at registration (e.g. "US"). Required when the challenge has Challenge.eligibilityGeo configured.
     * @type {string}
     * @memberof ChallengeRegisterRequest
     */
    declaredCountry?: string;
    /**
     * U.S. state code the user selected at registration (e.g. "CA"). Required when declaredCountry is "US" and Challenge.eligibilityGeo is configured.
     * @type {string}
     * @memberof ChallengeRegisterRequest
     */
    declaredState?: string;
}

/**
 * Check if a given object implements the ChallengeRegisterRequest interface.
 */
export function instanceOfChallengeRegisterRequest(value: object): value is ChallengeRegisterRequest {
    if (!('termsVersion' in value) || value['termsVersion'] === undefined) return false;
    return true;
}

export function ChallengeRegisterRequestFromJSON(json: any): ChallengeRegisterRequest {
    return ChallengeRegisterRequestFromJSONTyped(json, false);
}

export function ChallengeRegisterRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChallengeRegisterRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'eligibility': json['eligibility'] == null ? undefined : ChallengeEligibilityMapFromJSON(json['eligibility']),
        'termsVersion': json['termsVersion'],
        'declaredCountry': json['declaredCountry'] == null ? undefined : json['declaredCountry'],
        'declaredState': json['declaredState'] == null ? undefined : json['declaredState'],
    };
}

export function ChallengeRegisterRequestToJSON(json: any): ChallengeRegisterRequest {
    return ChallengeRegisterRequestToJSONTyped(json, false);
}

export function ChallengeRegisterRequestToJSONTyped(value?: ChallengeRegisterRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'eligibility': ChallengeEligibilityMapToJSON(value['eligibility']),
        'termsVersion': value['termsVersion'],
        'declaredCountry': value['declaredCountry'],
        'declaredState': value['declaredState'],
    };
}

